import { useCallback, useState } from 'react';
import { useAppSelector } from 'lib/hooks';
import { selectPreferredPlanYear } from 'slices/selectors';

/**
 * preferredShoppingYear is stored in sessionStorage, not the SSR preload.
 * A reload restores it after mount, via AppInitializer, so the preferred
 * year can arrive while the page is already showing the default. Follow
 * that update until the member picks a year themselves.
 */
export function usePreferredPlanYearSelection() {
  const preferredPlanYear = useAppSelector(selectPreferredPlanYear);
  const [yearOverride, setYearOverride] = useState<string | null>(null);

  const choosePlanYear = useCallback((year: string) => {
    setYearOverride(year);
  }, []);

  return [yearOverride ?? String(preferredPlanYear), choosePlanYear] as const;
}
